import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Badge from "../../components/common/Badge/Badge";
import Button from "../../components/common/Button/Button";
import TabsNavigation from "../../components/common/TabsNavigation/TabsNavigation";
import Table from "../../components/common/Table/Table";
import BarChartGraph from "../../components/common/Charts/BarChartGraph";
import { getApiInstance } from "../../utils/api";
import "./FichaCentroProductor.scss";
import DetalleLayout from "../../Layouts/DetalleLayout/DetalleLayout";
import CardCharts from "../../components/common/CardCharts/CardCharts";
import InputDropdown from "../../components/common/Inputs/InputDropdown/InputDropdown";
import { useZone } from "../../context/ZoneContext";
import { CiClock1 } from "react-icons/ci";
import { CgDanger } from "react-icons/cg";
import { CiCircleCheck } from "react-icons/ci";
import { IoTrashOutline } from "react-icons/io5";
import { addOrUpdateRecentItem, mapList } from "../../utils/utils";
import { formatDate } from "../../utils/utils";
import PieChartGraph from "../../components/common/Charts/PieChartGraph";
import { getConfig } from "../../utils/config";
import Tabs from "../../components/common/Tabs/Tabs";
import ScrollableBarChartGraph from "../../components/common/Charts/ScrollableBarChartGraph";

const formatKg = (value) => new Intl.NumberFormat("es-ES").format(value);

export default function FichaCentroProductor({ user }) {
    const { id } = useParams();
    const [centro, setCentro] = useState(null);
    const [documentos, setDocumentos] = useState([]);
    const [cumplimientoLegal, setCumplimientoLegal] = useState([]);
    const [residuos, setResiduos] = useState(null);
    const [residuosAgrupados, setResiduosAgrupados] = useState([]);
    const [residuosGenerados, setResiduosGenerados] = useState([]);
    const [tarifas, setTarifas] = useState([]);
    const [imagenes, setImagenes] = useState([]);
    const [activeTabDatos, setActiveTabDatos] = useState("informacion");
    const [activeTabResiduos, setActiveTabResiduos] = useState("cantidades");
    const [activeTabDocumentacion, setActiveTabDocumentacion] =
        useState("documentacion");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [openDropdownRowId, setOpenDropdownRowId] = useState(null);
    const { selectedZone } = useZone();
    const [distribuidoras, setDistribuidoras] = useState([]);
    const [consumo, setConsumo] = useState([]);
    const [proyectos, setProyectos] = useState([]);
    const [transportistas, setTransportistas] = useState([]);
    const [neveras, setNeveras] = useState([]);
    const [vehiculos, setVehiculos] = useState([]);
    const [combustibles, setCombustibles] = useState([]);
    const [gestores, setGestores] = useState([]);
    const [rutas, setRutas] = useState(null);
    const [tiposTratamiento, setTiposTratamiento] = useState([]);
    const [residuosObraGroupped, setResiduosObraGroupped] = useState([]);
    const [datosProcesadosBar, setDatosProcesadosBar] = useState([]);
    const [datosProcesadosPie, setDatosProcesadosPie] = useState([]);
    const [totalCantidadGenerada, setTotalCantidadGenerada] = useState(0);
    const [totalValorizacion, setTotalValoracion] = useState(0);
    const [totalEliminacion, setTotalEliminacion] = useState(0);
    const [porcentajeValorizacion, setPorcentajeValorizacion] = useState(0);
    const [porcentajeEliminacion, setPorcentajeEliminacion] = useState(0);
    const [tiposDocumentosObligatorios, setTiposDocumentosObligatorios] =
        useState([]);
    const [tiposDocumentosNoObligatorios, setTiposDocumentosNoObligatorios] =
        useState([]);
    const [selectedPeriod, setSelectedPeriod] = useState("Mes");
    const [residuosAgrupadosRME, setResiduosAgrupadosRME] = useState([]);

    const config = getConfig();
    const isMabe = config?.REACT_APP_IS_MABE === "true";

    const formElementsDocumentos = [
        {
            elements: [
                {
                    name: "codTipoDocumento",
                    type: "radio",
                    label: "Tipo de documento",
                    placeholder: "Seleccione el tipo de documento",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    options: [
                        {
                            label: "Documentación obligatoria",
                            options: tiposDocumentosObligatorios,
                        },
                        {
                            label: "Documentacion no obligatoria",
                            options: tiposDocumentosNoObligatorios,
                        },
                    ],
                },
                {
                    name: "fichero",
                    type: "document",
                    label: "Documento",
                    placeholder: "Subir documento",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "observaciones",
                    type: "textarea",
                    label: "Observaciones",
                    placeholder: "Escriba las observaciones aquí",
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "codObra",
                    type: "text",
                    label: "Código Obra",
                    placeholder: "",
                    required: false,
                    disabled: true,
                    labelVisible: false,
                    visible: false,
                    defaultValue: id,
                },
            ],
        },
    ];

    const getValorizacionEfectiva = (item) => {
        const valorizacionUtil =
            item.valorizacion != null && item.valorizacion !== 0
                ? item.valorizacion
                : null;

        return item.porcentaje2 ?? valorizacionUtil ?? item.porcentaje1 ?? null;
    };

    const getFechaResiduo = (item) => {
        return (
            item.fechaGestionIntermedia ??
            item.fechaTransporte ??
            item.createdAt ??
            null
        );
    };

    const procesarValorizacionParaBarChart = (residuos) => {
        const currentYear = new Date().getFullYear();

        const meses = [
            "Ene",
            "Feb",
            "Mar",
            "Abr",
            "May",
            "Jun",
            "Jul",
            "Ago",
            "Sep",
            "Oct",
            "Nov",
            "Dic",
        ];

        const agrupadoMeses = meses.map((mes) => ({
            name: mes,
            Valorización: 0,
        }));

        const agrupadoAnios = {};

        residuos.forEach((item) => {
            const fechaRaw = getFechaResiduo(item);

            if (!fechaRaw) return;

            const fecha = new Date(fechaRaw);

            if (Number.isNaN(fecha.getTime())) return;

            const year = fecha.getFullYear();
            const month = fecha.getMonth();

            const peso = Number(item.peso) || 0;
            const valorizacionEfectiva = getValorizacionEfectiva(item);

            const valorizado =
                valorizacionEfectiva != null
                    ? (Number(valorizacionEfectiva) * peso) / 100
                    : 0;

            if (year === currentYear) {
                agrupadoMeses[month].Valorización += valorizado;
            }

            if (!agrupadoAnios[year]) {
                agrupadoAnios[year] = {
                    name: String(year),
                    Valorización: 0,
                };
            }

            agrupadoAnios[year].Valorización += valorizado;
        });

        return {
            Mes: agrupadoMeses.map((item) => ({
                ...item,
                Valorización: Number(item.Valorización.toFixed(2)),
            })),

            Año: Object.values(agrupadoAnios)
                .sort((a, b) => Number(a.name) - Number(b.name))
                .map((item) => ({
                    ...item,
                    Valorización: Number(item.Valorización.toFixed(2)),
                })),
        };
    };

    useEffect(() => {
        if (centro != null) {
            addOrUpdateRecentItem({
                id: centro.codObra,
                title: centro.nombre,
                type: "centroProductor",
            });
        }
    }, [centro]);

    useEffect(() => {
        let isMounted = true;
        setLoading(true);
        setError(null);

        const loadAll = async () => {
            try {
                const obra = await fetchCentroProductor(id);

                if (isMounted) {
                    setCentro(obra);
                    setResiduosGenerados(obra.residuos);
                }

                const residuosGrouped = [];
                obra.residuos.forEach((currentItem) => {
                    const existingGroup = residuosGrouped.find(
                        (group) => group.codResiduo === currentItem.codResiduo
                    );

                    if (existingGroup) {
                        existingGroup.peso += currentItem.peso;
                        existingGroup.costeTotal += currentItem.costeTotal;

                        const valorizacionUtil =
                            currentItem.valorizacion != null &&
                            currentItem.valorizacion !== 0
                                ? currentItem.valorizacion
                                : null;

                        const valorizacionEfectiva =
                            currentItem.porcentaje2 ??
                            valorizacionUtil ??
                            currentItem.porcentaje1 ??
                            null;

                        if (valorizacionEfectiva != null) {
                            existingGroup.pesoConDatoValorizacion +=
                                currentItem.peso;

                            if (existingGroup.valorizacion == null) {
                                existingGroup.valorizacion = 0;
                            }

                            existingGroup.valorizacion +=
                                (valorizacionEfectiva * currentItem.peso) / 100;
                        } else {
                            existingGroup.pesoSinDatoValorizacion +=
                                currentItem.peso;
                        }
                    } else {
                        const valorizacionUtil =
                            currentItem.valorizacion != null &&
                            currentItem.valorizacion !== 0
                                ? currentItem.valorizacion
                                : null;

                        const valorizacionEfectiva =
                            currentItem.porcentaje2 ??
                            valorizacionUtil ??
                            currentItem.porcentaje1 ??
                            null;

                        const newGroup = {
                            codObra: id,
                            codResiduo: currentItem.codResiduo,
                            codTipoResiduo: currentItem.codTipoResiduo,
                            residuo:
                                currentItem.residuo.codigo != null &&
                                currentItem.residuo.codigo !== "" &&
                                currentItem.residuo.codigo !== undefined
                                    ? currentItem.residuo.codigo +
                                      " - " +
                                      currentItem.residuo.nombre
                                    : currentItem.residuo.nombre,

                            peso: currentItem.peso,

                            pesoConDatoValorizacion:
                                valorizacionEfectiva != null
                                    ? currentItem.peso
                                    : 0,
                            pesoSinDatoValorizacion:
                                valorizacionEfectiva == null
                                    ? currentItem.peso
                                    : 0,

                            valorizacion:
                                (valorizacionEfectiva * currentItem.peso) / 100,
                            costeTotal: currentItem.costeTotal,
                        };

                        residuosGrouped.push(newGroup);
                    }
                });

                const agregadosBar = obra.residuos
                    .filter((item) => item.codTipoResiduo == 4)
                    .reduce((acc, item) => {
                        const residuoKey =
                            item.residuo.codigo != "" &&
                            item.residuo.codigo != null &&
                            item.residuo.codigo !== undefined
                                ? `${item.residuo.codigo} - ${item.residuo.nombre}`
                                : item.residuo.nombre;

                        if (!acc[residuoKey]) {
                            acc[residuoKey] = { valorizado: 0, eliminado: 0 };
                        }
                        acc[residuoKey].valorizado +=
                            (item.porcentaje2 * item.peso) / 100 || 0;
                        acc[residuoKey].eliminado += item.eliminacion || 0;
                        return acc;
                    }, {});

                const datosProcesadosBar = Object.keys(agregadosBar).map(
                    (residuo) => ({
                        name: residuo,
                        Valorización: agregadosBar[residuo].valorizado,
                    })
                );

                const datosValorizacionBar = procesarValorizacionParaBarChart(
                    obra.residuos
                );

                const totalValorizado = obra.residuos.reduce(
                    (sum, item) =>
                        sum + ((item.porcentaje2 * item.peso) / 100 || 0),
                    0
                );
                const totalEliminado = obra.residuos.reduce(
                    (sum, item) => sum + (item.eliminacion || 0),
                    0
                );
                const granTotal = totalValorizado + totalEliminado;
                const porcVal =
                    granTotal > 0 ? (totalValorizado / granTotal) * 100 : 0;
                const porcElim =
                    granTotal > 0 ? (totalEliminado / granTotal) * 100 : 0;

                const datosProcesadosPie = [
                    {
                        name: "Valorización",
                        value: parseFloat(porcVal.toFixed(2)),
                    },
                    {
                        name: "Eliminación",
                        value: parseFloat(porcElim.toFixed(2)),
                    },
                ];

                if (isMounted) {
                    setResiduosObraGroupped(residuosGrouped);
                    setDatosProcesadosBar(datosValorizacionBar);
                    setDatosProcesadosPie(datosProcesadosPie);
                    setTotalCantidadGenerada(granTotal);
                    setTotalValoracion(totalValorizado);
                    setTotalEliminacion(totalEliminado);
                    setPorcentajeValorizacion(porcVal);
                    setPorcentajeEliminacion(porcElim);
                    setResiduosAgrupadosRME(datosProcesadosBar);
                }

                const results = await Promise.allSettled([
                    fetchDocumentosCentroProductor(id),
                    fetchElectricas(),
                    fetchConsumo(id),
                    fetchResiduos(),
                    fetchProyectos(),
                    fetchResiduosTiposTratamiento(),
                    fetchTiposVehiculos(),
                    fetchTiposCombustible(),
                    fetchImagenes(id),
                    fetchTarifas(id),
                    fetchTiposDocumentos(),
                    fetchProveedores(),
                    fetchRutas(),
                ]);

                const [
                    documentosResult,
                    electricasResult,
                    consumoResult,
                    residuosResult,
                    proyectosResult,
                    tiposTratamientoResult,
                    vehiculosResult,
                    combustiblesResult,
                    imagenesResult,
                    tarifasResult,
                    tiposDocumentosResult,
                    proveedoresResult,
                    rutasResult,
                ] = results;

                if (isMounted) {
                    if (!isMabe) {
                        try {
                            const neverasData = await fetchNeveras();
                            setNeveras(neverasData);
                        } catch (error) {
                            console.warn(
                                "No se pudieron cargar las neveras:",
                                error
                            );
                        }
                    } else {
                        setNeveras([]);
                    }

                    if (documentosResult.status === "fulfilled") {
                        setDocumentos(documentosResult.value);
                    } else {
                        console.warn(
                            "No se pudieron cargar los documentos:",
                            documentosResult.reason
                        );
                    }

                    if (electricasResult.status === "fulfilled") {
                        setDistribuidoras(
                            mapList(
                                electricasResult.value,
                                "nombre",
                                "codElectrica"
                            )
                        );
                    } else {
                        console.warn(
                            "No se pudieron cargar las eléctricas:",
                            electricasResult.reason
                        );
                    }

                    if (consumoResult.status === "fulfilled") {
                        setConsumo(consumoResult.value);
                    } else {
                        console.warn(
                            "No se pudo cargar el consumo:",
                            consumoResult.reason
                        );
                    }

                    if (residuosResult.status === "fulfilled") {
                        setResiduos([
                            ...mapList(
                                residuosResult.value,
                                "nombre",
                                "codResiduo"
                            ),
                        ]);
                    } else {
                        console.warn(
                            "No se pudieron cargar los residuos:",
                            residuosResult.reason
                        );
                    }

                    if (proyectosResult.status === "fulfilled") {
                        setProyectos([
                            ...mapList(
                                proyectosResult.value,
                                "proyecto",
                                "codProyecto"
                            ),
                        ]);
                    } else {
                        console.warn(
                            "No se pudieron cargar los proyectos:",
                            proyectosResult.reason
                        );
                    }

                    if (rutasResult.status === "fulfilled") {
                        setRutas([
                            ...mapList(rutasResult.value, "ruta", "codRuta"),
                        ]);
                    } else {
                        console.warn(
                            "No se pudieron cargar las rutas:",
                            rutasResult.reason
                        );
                    }

                    if (proveedoresResult.status === "fulfilled") {
                        setTransportistas([
                            ...mapList(
                                proveedoresResult.value.filter(
                                    (x) => x.isTransportista && x.codEstado == 3
                                ),
                                "nombre",
                                "codProveedor",
                                "codResiduo",
                                "codsResiduos"
                            ),
                        ]);
                        setGestores([
                            ...mapList(
                                proveedoresResult.value.filter(
                                    (x) => x.isGestorFinal && x.codEstado == 3
                                ),
                                "nombre",
                                "codProveedor",
                                "codResiduo",
                                "codsResiduos"
                            ),
                        ]);
                    }

                    if (tiposTratamientoResult.status === "fulfilled") {
                        setTiposTratamiento([
                            ...mapList(
                                tiposTratamientoResult.value,
                                ["codigo", "descripcion"],
                                "codTipoTratamiento",
                                "codTipoTratamiento",
                                "tipo"
                            ),
                        ]);
                    } else {
                        console.warn(
                            "No se pudieron cargar los tipos de tratamiento:",
                            tiposTratamientoResult.reason
                        );
                    }

                    if (vehiculosResult.status === "fulfilled") {
                        setVehiculos([
                            ...mapList(
                                vehiculosResult.value,
                                "vehiculo",
                                "codVehiculo"
                            ),
                        ]);
                    } else {
                        console.warn(
                            "No se pudieron cargar los tipos de vehículos:",
                            vehiculosResult.reason
                        );
                    }

                    if (combustiblesResult.status === "fulfilled") {
                        setCombustibles([
                            ...mapList(
                                combustiblesResult.value,
                                "combustible",
                                "codCombustible",
                                "codVehiculo",
                                "codsVehiculo"
                            ),
                        ]);
                    } else {
                        console.warn(
                            "No se pudieron cargar los tipos de combustible:",
                            combustiblesResult.reason
                        );
                    }

                    if (imagenesResult.status === "fulfilled") {
                        setImagenes(imagenesResult.value);
                    } else {
                        console.warn(
                            "No se pudieron cargar las imágenes:",
                            imagenesResult.reason
                        );
                    }

                    if (tarifasResult.status === "fulfilled") {
                        setTarifas(tarifasResult.value);
                    } else {
                        console.warn(
                            "No se pudieron cargar las imágenes:",
                            tarifasResult.reason
                        );
                    }

                    if (tiposDocumentosResult.status === "fulfilled") {
                        const tiposDocObligatorios =
                            tiposDocumentosResult.value.filter(
                                (doc) => doc.obligatorio
                            );
                        const tiposDocNoObligatorios =
                            tiposDocumentosResult.value.filter(
                                (doc) => !doc.obligatorio
                            );
                        setTiposDocumentosObligatorios([
                            ...mapList(
                                tiposDocObligatorios,
                                "descripcion",
                                "codTipoDocumento"
                            ),
                        ]);
                        setTiposDocumentosNoObligatorios([
                            ...mapList(
                                tiposDocNoObligatorios,
                                "descripcion",
                                "codTipoDocumento"
                            ),
                        ]);
                        console.log(tiposDocObligatorios);
                        console.log(tiposDocNoObligatorios);
                    } else {
                        console.warn(
                            "No se pudieron cargar los tipos documento:",
                            tiposDocumentosResult.reason
                        );
                    }
                }
            } catch (err) {
                if (isMounted) {
                    setError(
                        "No se han podido cargar los datos principales. Vuelve a intentarlo más tarde."
                    );
                }
                console.error("Error en datos críticos de loadAll:", err);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        loadAll();

        return () => {
            isMounted = false;
        };
    }, [id, selectedZone]);

    const fetchCentroProductor = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/Obra/GetObra/${selectedZone.value}/1/${id}/es`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching gestor:", error);
            throw error;
        }
    };

    const fetchDocumentosCentroProductor = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/ObraDocumento/GetDocumentosFromObra/${id}`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching gestor:", error);
            throw error;
        }
    };

    const fetchConsumo = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/Consumo/GetConsumoByCodObra/${id}`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching gestor:", error);
            throw error;
        }
    };

    const fetchElectricas = async () => {
        try {
            const api = getApiInstance();
            const response = await api.get(`/api/Electrica/GetAllElectricas`);
            return await response.data;
        } catch (error) {
            console.error("Error fetching gestor:", error);
            throw error;
        }
    };

    const fetchResiduos = async () => {
        const api = getApiInstance();
        try {
            const response = await api.get(
                `/api/Residuos/GetResiduosByZona/?codZona=${selectedZone.value}`
            );
            console.log("Residuos fetched:", response.data);
            return await response.data;
        } catch (err) {
            console.error(err);
            throw error;
        }
    };

    const fetchProyectos = async () => {
        try {
            const api = getApiInstance();
            const response = await api.get(`/api/Proyecto/GetProyectos`);
            return await response.data;
        } catch (error) {
            console.error("Error fetching proyectos:", error);
            throw error;
        }
    };

    const fetchRutas = async () => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/Ruta/GetRutasByZona/${selectedZone.value}`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching rutas:", error);
            throw error;
        }
    };

    const fetchProveedores = async () => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/Proveedores/GetProveedoresByZona/?CodZona=${selectedZone.value}&CodZonaLegal=1`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching proyectos:", error);
            throw error;
        }
    };

    const fetchResiduosTiposTratamiento = async () => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/ResiduosTipoTratamiento/GetResiduosTipoTratamiento/${selectedZone.value}/es`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching tipos tratamiento:", error);
            throw error;
        }
    };

    const fetchTiposVehiculos = async () => {
        try {
            const api = getApiInstance();
            const response = await api.get(`/api/Huella/GetTiposVehiculo`);
            return await response.data;
        } catch (error) {
            console.error("Error fetching tipos vehiculos:", error);
            throw error;
        }
    };

    const fetchTiposCombustible = async () => {
        try {
            const api = getApiInstance();
            const response = await api.get(`/api/Huella/GetTiposCombustible`);
            return await response.data;
        } catch (error) {
            console.error("Error fetching tipos combustible:", error);
            throw error;
        }
    };

    const fetchImagenes = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(`/api/Obra/GetImagenesObra/${id}`);

            return await response.data;
        } catch (error) {
            console.error("Error fetching imágenes:", error);
            throw error;
        }
    };

    const fetchTarifas = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/Tarifa/GetTarifasAsignadasByObra/${id}`
            );

            console.log("Tarifas fetched:", response.data);

            return await response.data;
        } catch (error) {
            console.error("Error fetching imágenes:", error);
            throw error;
        }
    };

    const fetchNeveras = async () => {
        try {
            const api = getApiInstance();
            const response = await api.get(`/api/Neveras/GetAllNeveras/${id}`);
            return await response.data;
        } catch (error) {
            console.error("Error fetching proyectos:", error);
            throw error;
        }
    };

    const fetchTarifasProveedores = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/Tarifa/GetTarifasAsignadasByObra/${id}`
            );

            console.log("Tarifas fetched:", response.data);

            return await response.data;
        } catch (error) {
            console.error("Error fetching imágenes:", error);
            throw error;
        }
    };

    const fetchTiposDocumentos = async () => {
        try {
            // Productor = 1,
            // Gestor = 2,
            // Obra = 3,
            const api = getApiInstance();
            const response = await api.get(
                `/api/Documentos/GetTiposDocumentosByTipoEntidad/3/${selectedZone.value}`
            );

            console.log("Tipos Documentos fetched:", response.data);

            return await response.data;
        } catch (error) {
            console.error("Error fetching tipos documentos:", error);
            throw error;
        }
    };

    const handleTarifaChange = (id, nuevaTarifa) => {
        setTarifas((prevTarifas) =>
            prevTarifas.map((tarifa) =>
                tarifa.id === id ? { ...tarifa, tarifa: nuevaTarifa } : tarifa
            )
        );
    };

    const handleDropdownOpenChange = (rowId, isOpen) => {
        setOpenDropdownRowId(isOpen ? rowId : null);
    };

    const tabsDatos = [
        { id: "informacion", label: "Información General" },
        { id: "ubicacion", label: "Ubicación" },
    ];

    const tabsResiduos = [
        { id: "cantidades", label: "Cantidades generadas" },
        { id: "agrupados", label: "Residuos generados agrupados" },
        { id: "generados", label: "Residuos generados" },
        ...(!isMabe ? [{ id: "neveras", label: "Neveras" }] : []),
        { id: "tarifas", label: "Tarifas" },
    ];

    const tabsDocumentacion = [
        { id: "documentacion", label: "Documentación" },
        { id: "cumplimiento", label: "Cumplimiento legal" },
        { id: "imagenes", label: "Imágenes" },
    ];

    const renderInformacionGeneral = () => (
        <div className="ficha-centro__info">
            <div className="ficha-centro__field">
                <label>Código Centro:</label>
                <span>{centro.nombre || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Código Espacio:</label>
                <span>{centro.codEspacio || "'"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Tipo Centro:</label>
                <span>{centro.tipoObra || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>NIMA:</label>
                <span>{centro.nima || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Cadena:</label>
                <span>{centro.cadena || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Fecha inicio:</label>
                <span>{formatDate(centro.fechaInicio) || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Fecha fin:</label>
                <span>{formatDate(centro.fechaFin) || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Intermediario:</label>
                <span>{centro.intermediario || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Responsable:</label>
                <span>{centro.responsable || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Superficie:</label>
                <span>{centro.superficie || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Observaciones:</label>
                <span>{centro.observaciones || "-"}</span>
            </div>
        </div>
    );

    const renderUbicacion = () => (
        <div className="ficha-centro__info">
            <div className="ficha-centro__field">
                <label>Ubicación:</label>
                <span>{centro.ubicacion || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Dirección:</label>
                <span>{centro.direccion || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Localidad:</label>
                <span>{centro.localidad || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Provincia:</label>
                <span>{centro.provincia.provincia || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Comunidad:</label>
                <span>{centro.comunidad || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>País:</label>
                <span>{centro.pais || "-"}</span>
            </div>
        </div>
    );

    const renderDatosContent = () => {
        switch (activeTabDatos) {
            case "informacion":
                return renderInformacionGeneral();
            case "ubicacion":
                return renderUbicacion();
            default:
                return renderInformacionGeneral();
        }
    };

    const handleTabChange = (tabId) => {
        setSelectedPeriod(tabId);
    };

    const renderCantidadesGeneradas = () => (
        <div className="cantidades-generadas-content">
            <div className="graficas-card">
                <div className="charts-section">
                    <div className="chart-container bar-chart-container">
                        <div className="chart-header">
                            {/* <h3>Cantidad generada por Residuo</h3>
                            <div className="total-amount">
                                {formatKg(totalCantidadGenerada)} kg
                            </div> */}
                            <div className={`card-charts__info`}>
                                <div className="card-charts__text">
                                    <h3 className="card-charts__title">
                                        Cantidad generada por Residuo
                                    </h3>
                                    <p className="card-charts__subtitle">
                                        {formatKg(totalCantidadGenerada)} kg
                                    </p>
                                </div>
                                <Tabs
                                    onTabChange={handleTabChange}
                                    tabs={["Mes", "Año"]}
                                />
                            </div>
                        </div>
                        <div className="chart-wrapper">
                            <BarChartGraph
                                data={datosProcesadosBar}
                                activeTab={selectedPeriod}
                            />
                        </div>
                    </div>

                    {/* <CardCharts
                        title="Cantidad generada por Residuo"
                        data={datosProcesadosBar}
                        showTabs={true}
                        activePeriod={selectedPeriod}
                    >
                        <BarChartGraph
                            data={datosProcesadosBar}
                            activeTab={selectedPeriod}
                        />
                    </CardCharts> */}
                </div>
            </div>
        </div>
    );

    const renderImagenes = () => {
        const handleEliminarImagen = async (imagenId, fileName, codObra) => {
            console.log("Eliminar imagen:", imagenId, fileName, codObra);

            if (
                window.confirm(
                    "¿Estás seguro de que deseas eliminar esta imagen?"
                )
            ) {
                try {
                    const api = getApiInstance();
                    await api.delete(
                        `/api/Obra/DeleteImagen/${imagenId}/${codObra}/${fileName}`
                    );
                    setImagenes(
                        imagenes.filter((img) => img.codImagen !== imagenId)
                    );
                } catch (error) {
                    console.error("Error eliminando imagen:", error);
                    alert("Error al eliminar la imagen. Inténtalo de nuevo.");
                }
            }
        };

        const handleSubirImagenes = async (e) => {
            const files = e.target.files;
            if (!files || files.length === 0) return;

            try {
                const api = getApiInstance();
                const formData = new FormData();

                for (const file of files) {
                    formData.append("Imagenes", file);
                }

                const { data } = await api.post(
                    `/api/Obra/SetImage/${id}`,
                    formData,
                    {
                        headers: { "Content-Type": "multipart/form-data" },
                    }
                );

                const imagenesActualizadas = await fetchImagenes(id);
                setImagenes(imagenesActualizadas);
            } catch (error) {
                console.error("Error subiendo imágenes:", error);
                alert("Error al subir las imágenes. Inténtalo de nuevo.");
            } finally {
                // Resetea el input para poder volver a seleccionar el mismo archivo si se desea
                e.target.value = "";
            }
        };

        const formatearFecha = (fechaString) => {
            const fecha = new Date(fechaString);
            const dia = String(fecha.getDate()).padStart(2, "0");
            const mes = String(fecha.getMonth() + 1).padStart(2, "0");
            const año = fecha.getFullYear();
            const horas = String(fecha.getHours()).padStart(2, "0");
            const minutos = String(fecha.getMinutes()).padStart(2, "0");
            const segundos = String(fecha.getSeconds()).padStart(2, "0");
            return `${dia}/${mes}/${año} ${horas}:${minutos}:${segundos}`;
        };

        if (!imagenes || imagenes.length === 0) {
            return (
                <div className="imagenes-section">
                    <div className="imagenes-upload-area">
                        <div className="imagenes-upload-content">
                            <p>Haz click aquí para subir imágenes</p>
                            <input
                                type="file"
                                accept="image/*"
                                multiple
                                onChange={handleSubirImagenes}
                                style={{ display: "none" }}
                                id="upload-imagenes"
                            />
                            <label
                                htmlFor="upload-imagenes"
                                className="upload-label"
                            >
                                Seleccionar archivos
                            </label>
                        </div>
                    </div>
                    <div className="imagenes-empty">
                        <p>Actualmente no hay imágenes para mostrar</p>
                    </div>
                </div>
            );
        }

        return (
            <div className="imagenes-section">
                <div className="imagenes-upload-area">
                    <div className="imagenes-upload-content">
                        <p>Haz click aquí para subir imágenes</p>
                        <input
                            type="file"
                            accept="image/*"
                            multiple
                            onChange={handleSubirImagenes}
                            style={{ display: "none" }}
                            id="upload-imagenes"
                        />
                        <label
                            htmlFor="upload-imagenes"
                            className="upload-label"
                        >
                            Seleccionar archivos
                        </label>
                    </div>
                </div>
                <div className="imagenes-grid">
                    {imagenes.map((imagen) => (
                        <div key={imagen.codImagen} className="imagen-card">
                            <div className="imagen-thumbnail">
                                <img
                                    src={`data:image/png;base64,${imagen.fileBase64}`}
                                    alt={`Imagen ${imagen.codImagen}`}
                                />
                            </div>
                            <div className="imagen-info">
                                <div className="imagen-detalles">
                                    <p className="imagen-usuario">
                                        {imagen.usuario || "Usuario"}
                                    </p>
                                    <p className="imagen-fecha">
                                        {formatearFecha(imagen.fechaSubida)}
                                    </p>
                                </div>
                                <button
                                    className="eliminar-imagen-btn"
                                    onClick={() =>
                                        handleEliminarImagen(
                                            imagen.codImagen,
                                            imagen.fileName,
                                            id
                                        )
                                    }
                                    aria-label="Eliminar imagen"
                                    title="Eliminar imagen"
                                >
                                    <IoTrashOutline />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const renderRMEGraficoContent = () => {
        return (
            <div className="chart-card">
                <div className="chart-card__header">
                    <div>
                        <h3 className="chart-card__title">
                            Cantidad generada por Residuo
                        </h3>
                        <p className="chart-card__subtitle">
                            Distribución de residuos por tipo y tratamiento
                        </p>
                    </div>
                </div>
                {/* 
                        <div className="chart-card__filter">
                            <InputDropdown
                                value={selectedResiduos}
                                options={residuosDisponibles}
                                onChange={(selectedOptions) => {
                                    setSelectedResiduos(
                                        Array.isArray(selectedOptions)
                                            ? selectedOptions
                                            : []
                                    );
                                }}
                                placeholder="Filtrar por tipo de residuo"
                                labelVisible={false}
                                isMultiple={true}
                                clearable={true}
                            />
                        </div> */}

                <div className="chart-card__body">
                    <ScrollableBarChartGraph data={residuosAgrupadosRME} />
                </div>
            </div>
        );
    };

    const renderDocumentacionContent = () => {
        switch (activeTabDocumentacion) {
            case "documentacion":
                return (
                    <div className="ficha-centro__documentacion">
                        <Table
                            columns={[
                                {
                                    key: "tipoDocumento",
                                    label: "Tipo de documento",
                                    visible: true,
                                    sortable: true,
                                },
                                {
                                    key: "documento",
                                    label: "Documento",
                                    visible: true,
                                    sortable: true,
                                    documentProp: "ficheroBase64",
                                    type: "document",
                                },
                                {
                                    key: "codEstado",
                                    label: "Validación",
                                    visible: true,
                                    sortable: true,
                                },
                            ]}
                            dataTable={documentos}
                            noResultsMessage="No hay documentos disponibles"
                            rowsPerPage={10}
                            showCheckboxes={false}
                            actions={["Eliminar"]}
                            elementName="Documento"
                            keyProp="codDocumento"
                            stateProp="codEstado"
                            states={[
                                {
                                    label: "Sin datos",
                                    type: "info",
                                    Icon: CiClock1,
                                },
                                {
                                    label: "Pendiente de validar",
                                    type: "info",
                                    Icon: CiClock1,
                                },
                                {
                                    label: "Validación con incidencias",
                                    type: "danger",
                                    Icon: CgDanger,
                                },
                                {
                                    label: "Validada",
                                    type: "success",
                                    Icon: CiCircleCheck,
                                },
                            ]}
                            stateChangeOptions={[
                                { value: "1", label: "Pendiente de validar" },
                                {
                                    value: "2",
                                    label: "Validación con incidencias",
                                },
                                { value: "3", label: "Validada" },
                            ]}
                            stateChangeUrl="/api/Validaciones/SetValidacion"
                            formElements={formElementsDocumentos}
                            addApiUrl="/api/ObraDocumento/SetDocumento"
                            deleteApiUrl="/api/ObraDocumento/DeleteDocumento"
                            userCodAcceso={Number(user.codAcceso)}
                            userCodPerfil={Number(user.role)}
                            loading={loading}
                        />
                    </div>
                );
            case "cumplimiento":
                return (
                    <div className="ficha-centro__cumplimiento">
                        <Table
                            columns={[
                                {
                                    key: "nombre",
                                    label: "Descripción",
                                    visible: true,
                                    sortable: true,
                                },
                                {
                                    key: "codEstado",
                                    label: "Estado",
                                    visible: true,
                                    sortable: true,
                                },
                            ]}
                            dataTable={centro.cumplimientos}
                            noResultsMessage="No hay datos de cumplimiento legal disponibles"
                            rowsPerPage={10}
                            showCheckboxes={false}
                            elementName="Cumplimiento"
                            states={[
                                {
                                    label: "Sin datos",
                                    type: "info",
                                    Icon: CiClock1,
                                },
                                {
                                    label: "Pendiente",
                                    type: "info",
                                    Icon: CiClock1,
                                },
                                {
                                    label: "Sin validar",
                                    type: "warning",
                                    Icon: CiClock1,
                                },
                                {
                                    label: "Validado",
                                    type: "success",
                                    Icon: CiClock1,
                                },
                            ]}
                            stateProp="codEstado"
                            sortProp="descripcion"
                            userCodAcceso={Number(user.codAcceso)}
                            userCodPerfil={Number(user.role)}
                            loading={loading}
                        />
                    </div>
                );
            case "imagenes":
                return renderImagenes();
            default:
                return (
                    <div className="ficha-centro__documentacion">
                        <Table
                            columns={[
                                {
                                    key: "tipoDocumento",
                                    label: "Tipo de documento",
                                    visible: true,
                                    sortable: true,
                                },
                                {
                                    key: "documento",
                                    label: "Documento",
                                    visible: true,
                                    sortable: true,
                                    documentProp: "ficheroBase64",
                                    type: "document",
                                },
                                {
                                    key: "codEstado",
                                    label: "Validación",
                                    visible: true,
                                    sortable: true,
                                },
                            ]}
                            dataTable={documentos}
                            noResultsMessage="No hay documentos disponibles"
                            rowsPerPage={10}
                            showCheckboxes={false}
                            actions={["Editar", "Eliminar"]}
                            elementName="Documento"
                            stateProp="codEstado"
                            states={[
                                {
                                    label: "Sin datos",
                                    type: "info",
                                    Icon: CiClock1,
                                },
                                {
                                    label: "Pendiente de validar",
                                    type: "info",
                                    Icon: CiClock1,
                                },
                                {
                                    label: "Validación con incidencias",
                                    type: "danger",
                                    Icon: CgDanger,
                                },
                                {
                                    label: "Validada",
                                    type: "success",
                                    Icon: CiCircleCheck,
                                },
                            ]}
                            formElements={formElementsDocumentos}
                            addApiUrl="/api/gestores/documentos"
                            editApiUrl="/api/gestores/documentos"
                            deleteApiUrl="/api/gestores/documentos"
                            userCodAcceso={Number(user.codAcceso)}
                            userCodPerfil={Number(user.role)}
                            loading={false}
                        />
                    </div>
                );
        }
    };

    const renderConsumo = () => (
        <Table
            columns={[
                {
                    key: "electrica",
                    label: "Eléctrica",
                    visible: true,
                    sortable: true,
                },
                {
                    key: "fechaInicio",
                    label: "Fecha inicio",
                    visible: true,
                    sortable: true,
                    type: "date",
                },
                {
                    key: "fechaFin",
                    label: "Fecha fin",
                    visible: true,
                    sortable: true,
                    type: "date",
                },
                {
                    key: "consumo",
                    label: "Consumo",
                    visible: true,
                    sortable: true,
                },
                {
                    key: "factura",
                    label: "Factura",
                    visible: true,
                    sortable: true,
                    type: "document",
                    documentProp: "ficheroBase64",
                },
            ]}
            dataTable={consumo}
            noResultsMessage="No hay datos de consumo disponibles"
            rowsPerPage={10}
            showCheckboxes={false}
            elementName="Consumo"
            sortProp="electrica"
            keyProp="codConsumo"
            actions={["Eliminar", "Editar"]}
            loading={loading}
            formElements={[
                {
                    elements: [
                        {
                            name: "codObra",
                            type: "text",
                            required: false,
                            disabled: false,
                            visible: false,
                            defaultValue: `${id}`,
                        },
                        {
                            name: "codElectrica",
                            type: "select",
                            label: "Distribuidora",
                            placeholder: "Seleccione una distribuidora",
                            options: distribuidoras,
                            required: true,
                            disabled: false,
                            labelVisible: true,
                            visible: true,
                        },
                        {
                            name: "codGarantia",
                            type: "select",
                            label: "Garantía de Origen (GDO)",
                            placeholder:
                                "¿Dispone de Garantía de Origen (GDO)?",
                            required: true,
                            disabled: false,
                            labelVisible: true,
                            visible: true,
                            options: [
                                { value: "1", label: "GdO energía renovable" },
                                {
                                    value: "2",
                                    label: "GdO cogeneración de alta eficiencia",
                                },
                                { value: "3", label: "No" },
                            ],
                        },
                        {
                            name: "fechaInicio",
                            type: "date",
                            label: "Fecha Inicio",
                            required: true,
                            disabled: false,
                            labelVisible: true,
                            visible: true,
                        },
                        {
                            name: "fechaFin",
                            type: "date",
                            label: "Fecha Fin",
                            required: true,
                            disabled: false,
                            labelVisible: true,
                            visible: true,
                        },
                        {
                            name: "consumo",
                            type: "number",
                            label: "Consumo (kWh)",
                            placeholder: "Ingrese el consumo en kWh",
                            required: true,
                            disabled: false,
                            labelVisible: true,
                            visible: true,
                        },
                        {
                            name: "FicheroFactura",
                            type: "document",
                            label: "Factura",
                            placeholder: "Subir factura",
                            required: true,
                            disabled: false,
                            labelVisible: true,
                            visible: true,
                        },
                    ],
                },
            ]}
            addApiUrl="/api/Consumo/SetConsumo"
            editApiUrl="/api/Consumo/EditConsumo"
            deleteApiUrl="/api/Consumo/DeleteConsumo"
            userCodAcceso={Number(user.codAcceso)}
            userCodPerfil={Number(user.role)}
        />
    );

    async function handleBitacora() {
        const api = getApiInstance();
        const response = await api.post(
            `api/Obra/obtener-bitacora-mabe?codObra=${id}&codZona=${selectedZone.value}`,
            null,

            {
                responseType: "blob",
            }
        );

        if (response.status !== 200) {
            throw new Error("Error al generar la bitácora.");
        }
        const cd = response.headers["content-disposition"] || "";
        let fileName = `Informe_${id}.xlsx`;

        const utf8Match = cd.match(/filename\*=UTF-8''([^;]+)/i);

        const normalMatch = cd.match(/filename="?([^"]+)"?/i);

        const rawFileName = utf8Match?.[1] || normalMatch?.[1];

        if (rawFileName) {
            try {
                fileName = decodeURIComponent(rawFileName.trim());
            } catch {
                fileName = rawFileName.trim();
            }
        }
        // Blob
        const blob =
            response.data instanceof Blob
                ? response.data
                : new Blob([response.data], {
                      type:
                          response.headers["content-type"] ||
                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                  });

        const urlBlob = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = urlBlob;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(urlBlob);

        return { ok: true, fileName, size: blob.size };
    }

    return (
        <DetalleLayout
            title={
                centro
                    ? `Centro ${centro.codEspacio} - ${centro.direccion} -${centro.localidad}`
                    : "Cargando..."
            }
            backLink="/centros-productores"
            backText="Volver a Centros"
            loading={loading}
            error={error}
            notFound={!centro && !loading && !error}
            className="ficha-centro"
        >
            {isMabe && (
                <div className="ficha-centro__actions">
                    <Button
                        variant="filled"
                        onClick={handleBitacora}
                        className="ficha-centro__manifiesto-btn"
                    >
                        Obtener bitácora
                    </Button>
                </div>
            )}

            {!loading && !error && centro && (
                <div className="ficha-centro__content">
                    <div className="ficha-centro__section">
                        <div className="ficha-centro__section-header">
                            <h2>Datos del centro</h2>
                        </div>
                        <TabsNavigation
                            tabs={tabsDatos}
                            activeTab={activeTabDatos}
                            onTabChange={setActiveTabDatos}
                        />
                        <div className="ficha-centro__section-content">
                            {renderDatosContent()}
                        </div>
                    </div>
                    <div className="ficha-centro__section">
                        <div className="ficha-centro__section-header">
                            <h2>Residuos</h2>
                        </div>
                        <TabsNavigation
                            tabs={tabsResiduos}
                            activeTab={activeTabResiduos}
                            onTabChange={setActiveTabResiduos}
                        />
                        <div className="ficha-centro__section-content">
                            <div
                                style={{
                                    display:
                                        activeTabResiduos === "cantidades"
                                            ? "flex"
                                            : "none",
                                    flex: 1,
                                    height: "400px",
                                }}
                            >
                                {renderCantidadesGeneradas()}
                            </div>
                            <div
                                style={{
                                    display:
                                        activeTabResiduos === "agrupados"
                                            ? "block"
                                            : "none",
                                }}
                            >
                                {/* TABLE AGRUPADOS */}
                                <Table
                                    columns={[
                                        {
                                            key: "residuo",
                                            label: "Residuo",
                                            visible: true,
                                            sortable: true,
                                        },
                                        {
                                            key: "peso",
                                            label: "Peso",
                                            visible: true,
                                            sortable: true,
                                            render: (row) => (
                                                <span>{row.peso} kg</span>
                                            ),
                                        },
                                        {
                                            key: "valorizacion",
                                            label: "Valorización",
                                            visible: true,
                                            sortable: true,
                                            render: (row) => (
                                                <span>
                                                    {row.valorizacion} kg
                                                </span>
                                            ),
                                        },
                                        {
                                            key: "costeTotal",
                                            label: "Coste total",
                                            visible: true,
                                            sortable: true,
                                            render: (row) => (
                                                <span
                                                    className={`coste ${
                                                        row.costeTotal < 0
                                                            ? "coste--negative"
                                                            : "coste--positive"
                                                    }`}
                                                >
                                                    {row.costeTotal} $
                                                </span>
                                            ),
                                        },
                                    ]}
                                    dataTable={residuosObraGroupped}
                                    searchTerms={["residuo", "peso"]}
                                    noResultsMessage="No hay residuos agrupados disponibles"
                                    rowsPerPage={10}
                                    keyProp="codResiduo"
                                    sortProp="residuo"
                                    showCheckboxes={false}
                                    elementName="residuo"
                                    stateProp="estado"
                                    userCodAcceso={Number(user.codAcceso)}
                                    userCodPerfil={Number(user.role)}
                                    loading={false}
                                />
                            </div>
                            <div
                                style={{
                                    display:
                                        activeTabResiduos === "generados"
                                            ? "block"
                                            : "none",
                                }}
                            >
                                <Table
                                    columns={[
                                        {
                                            key: [
                                                "residuo/codigo",
                                                "residuo/nombre",
                                                "observacionesGestionFinal",
                                            ],
                                            label: "Residuo",
                                            visible: true,
                                            sortable: true,
                                        },
                                        {
                                            key: "fechaTransporte",
                                            label: "Fecha recogida",
                                            visible: true,
                                            sortable: true,
                                            type: "date",
                                        },
                                        {
                                            key: "peso",
                                            label: "Peso",
                                            visible: true,
                                            sortable: true,
                                            render: (row) => (
                                                <span>
                                                    {row.peso} {row.unidadPeso}
                                                </span>
                                            ),
                                        },
                                        {
                                            key: "valorizacion",
                                            label: "Valorización",
                                            visible: true,
                                            sortable: true,
                                            render: (row) => {
                                                if (
                                                    row.porcentaje2 === 0 ||
                                                    row.porcentaje2 === null
                                                ) {
                                                    return (
                                                        <span>Sin datos</span>
                                                    );
                                                }

                                                const obtenerEstiloDeProgreso =
                                                    (valor, maximo) => {
                                                        if (maximo === 0) {
                                                            return {
                                                                "--progress-color":
                                                                    "#f44336",
                                                            };
                                                        }

                                                        const porcentaje =
                                                            (valor / maximo) *
                                                            100;
                                                        let color;

                                                        if (porcentaje < 40) {
                                                            color = "#f44336";
                                                        } else if (
                                                            porcentaje < 75
                                                        ) {
                                                            color = "#ff9800";
                                                        } else {
                                                            color = "#4caf50";
                                                        }

                                                        return {
                                                            "--progress-color":
                                                                color,
                                                        };
                                                    };

                                                return (
                                                    <div className="valorizacion-container">
                                                        <span htmlFor="valorizacion">
                                                            {(row.peso *
                                                                row.porcentaje2) /
                                                                100}{" "}
                                                            / {row.peso}{" "}
                                                            {row.unidadPeso}
                                                        </span>
                                                        <progress
                                                            id="valorizacion"
                                                            value={
                                                                (row.peso *
                                                                    row.porcentaje2) /
                                                                100
                                                            }
                                                            max={row.peso}
                                                            className="progress-bar"
                                                            style={obtenerEstiloDeProgreso(
                                                                (row.peso *
                                                                    row.porcentaje2) /
                                                                    100,
                                                                row.peso
                                                            )}
                                                        ></progress>
                                                    </div>
                                                );
                                            },
                                        },
                                        {
                                            key: "costeTotal",
                                            label: "Coste final",
                                            visible: true,
                                            sortable: true,
                                            render: (row) => (
                                                <span
                                                    className={`coste ${
                                                        row.costeTotal < 0
                                                            ? "coste--negative"
                                                            : "coste--positive"
                                                    }`}
                                                >
                                                    {row.costeTotal}
                                                </span>
                                            ),
                                        },
                                        {
                                            key: "codEstado",
                                            label: "Validación",
                                            visible: true,
                                            sortable: true,
                                        },
                                    ]}
                                    dataTable={residuosGenerados}
                                    noResultsMessage="No hay residuos generados disponibles"
                                    rowsPerPage={10}
                                    showCheckboxes={false}
                                    actions={
                                        isMabe
                                            ? ["Editar", "Eliminar", "Exportar"]
                                            : ["Editar", "Eliminar"]
                                    }
                                    onDataUpdate={(newData) =>
                                        setResiduosGenerados(newData)
                                    }
                                    elementName="Residuo"
                                    sortProp="codResiduoObra"
                                    stateProp="codEstado"
                                    states={[
                                        {
                                            label: "Sin datos",
                                            type: "info",
                                            Icon: CiClock1,
                                        },
                                        {
                                            label: "Pendiente de validar",
                                            type: "info",
                                            Icon: CiClock1,
                                        },
                                        {
                                            label: "Validación con incidencias",
                                            type: "danger",
                                            Icon: CgDanger,
                                        },
                                        {
                                            label: "Validada",
                                            type: "success",
                                            Icon: CiCircleCheck,
                                        },
                                    ]}
                                    keyProp="codResiduoObra"
                                    formElements={[
                                        {
                                            title: "Residuo",
                                            titleVisible: true,
                                            elements: [
                                                {
                                                    name: "codResiduo",
                                                    type: "select",
                                                    label: "Tipo de residuo",
                                                    placeholder:
                                                        "Seleccione el tipo de residuo",
                                                    required: true,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                    options: residuos,
                                                },
                                                {
                                                    name: "codProyecto",
                                                    type: "select",
                                                    label: "Proyecto",
                                                    placeholder:
                                                        "Seleccione proyecto",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                    options: proyectos,
                                                },

                                                ...(!isMabe
                                                    ? [
                                                          {
                                                              name: "codRuta",
                                                              type: "select",
                                                              label: "Ruta",
                                                              placeholder:
                                                                  "Seleccione ruta",
                                                              required: false,
                                                              disabled: false,
                                                              labelVisible: true,
                                                              visible: true,
                                                              options: rutas,
                                                          },
                                                      ]
                                                    : []),

                                                {
                                                    name: "codObra",
                                                    type: "text",
                                                    label: "CodObra",
                                                    placeholder:
                                                        "Inserte codObra",
                                                    required: true,
                                                    disabled: false,
                                                    labelVisible: false,
                                                    visible: false,
                                                    defaultValue:
                                                        centro.codObra,
                                                },
                                                {
                                                    name: "codZona",
                                                    type: "text",
                                                    label: "CodZona",
                                                    placeholder:
                                                        "Inserte codZona",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: false,
                                                    visible: false,
                                                    defaultValue:
                                                        selectedZone.value,
                                                },
                                            ],
                                        },
                                        {
                                            title: "Transporte",
                                            titleVisible: true,
                                            elements: [
                                                {
                                                    name: isMabe
                                                        ? "codTransportista"
                                                        : "codTransportistas",
                                                    type: isMabe
                                                        ? "select"
                                                        : "multiselect",

                                                    label: "Transportista",
                                                    placeholder:
                                                        "Seleccione el transportista",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                    options: transportistas,
                                                    associatedFormElement:
                                                        "codResiduo",
                                                },
                                                {
                                                    name: "fechaTransporte",
                                                    type: "date",
                                                    label: "Fecha transporte",
                                                    placeholder:
                                                        "Seleccione la fecha de transporte",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                },
                                                {
                                                    name: "tipoVehiculo",
                                                    type: "select",
                                                    label: "Tipo de vehículo",
                                                    placeholder:
                                                        "Seleccione el tipo de vehículo",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                    options: vehiculos,
                                                },
                                                {
                                                    name: "tipoCombustible",
                                                    type: "select",
                                                    label: "Tipo de combustible",
                                                    placeholder:
                                                        "Seleccione el tipo de combustible",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                    options: combustibles,
                                                    associatedFormElement:
                                                        "tipoVehiculo",
                                                },
                                                {
                                                    name: "numKm",
                                                    type: "number",
                                                    label: "Número de Km",
                                                    placeholder:
                                                        "Ingrese el número de kilómetros",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                },
                                                {
                                                    name: "numViajes",
                                                    type: "number",
                                                    label: "Número de viajes",
                                                    placeholder:
                                                        "Ingrese el número de viajes",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                },
                                                {
                                                    name: "ficheroTransportista",
                                                    type: "document",
                                                    label: "Documento transporte",
                                                    placeholder:
                                                        "Seleccione el documento de transporte",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                },
                                            ],
                                        },
                                        {
                                            title: "Gestión intermedia",
                                            titleVisible: true,
                                            elements: [
                                                {
                                                    name: isMabe
                                                        ? "codGestorIntermedio"
                                                        : "codGestoresIntermedios",
                                                    type: isMabe
                                                        ? "select"
                                                        : "multiselect",

                                                    label: "Gestor intermedio",
                                                    placeholder:
                                                        "Seleccione el gestor intermedio",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                    options: gestores,
                                                    associatedFormElement:
                                                        "codResiduo",
                                                },
                                                {
                                                    name: "fechaGestionIntermedia",
                                                    type: "date",
                                                    label: "Fecha gestión intermedia",
                                                    placeholder:
                                                        "Seleccione la fecha de gestión intermedia",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                },
                                                // {
                                                //     name: "tipoTratamiento",
                                                //     type: "select",
                                                //     label: "Tipo de tratamiento",
                                                //     placeholder:
                                                //         "Seleccione el tipo de tratamiento",
                                                //     required: false,
                                                //     disabled: false,
                                                //     labelVisible: true,
                                                //     visible: true,
                                                //     options: [
                                                //         {
                                                //             value: "Eliminación",
                                                //             label: "Eliminación",
                                                //         },
                                                //         {
                                                //             value: "Valorización",
                                                //             label: "Valorización",
                                                //         },
                                                //     ],
                                                // },
                                                {
                                                    name: "codTipoTratamiento",
                                                    type: "select",
                                                    label: "Descripción tipo tratamiento",
                                                    placeholder:
                                                        "Ingrese la descripción del tipo de tratamiento",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                    options: tiposTratamiento,
                                                    associatedFormElement:
                                                        "tipoTratamiento",
                                                },
                                                {
                                                    name: "porcentaje",
                                                    type: "number",
                                                    label: "Porcentaje",
                                                    placeholder:
                                                        "Ingrese el porcentaje",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                },
                                            ],
                                        },
                                        {
                                            title: "Gestión final",
                                            titleVisible: true,
                                            elements: [
                                                {
                                                    name: isMabe
                                                        ? "codGestorFinal"
                                                        : "codGestoresFinales",
                                                    type: isMabe
                                                        ? "select"
                                                        : "multiselect",
                                                    label: "Gestor final",
                                                    placeholder:
                                                        "Seleccione el gestor final",
                                                    required: true,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                    options: gestores,
                                                    associatedFormElement:
                                                        "codResiduo",
                                                },
                                                {
                                                    name: "fechaGestionFinal",
                                                    type: "date",
                                                    label: "Fecha gestión final",
                                                    placeholder:
                                                        "Seleccione la fecha de gestión final",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                },
                                                // {
                                                //     name: "tipoTratamiento2",
                                                //     type: "select",
                                                //     label: "Tipo de tratamiento",
                                                //     placeholder:
                                                //         "Seleccione el tipo de tratamiento",
                                                //     required: false,
                                                //     disabled: false,
                                                //     labelVisible: true,
                                                //     visible: true,
                                                //     options: [
                                                //         {
                                                //             value: "Eliminación",
                                                //             label: "Eliminación",
                                                //         },
                                                //         {
                                                //             value: "Valorización",
                                                //             label: "Valorización",
                                                //         },
                                                //     ],
                                                // },
                                                {
                                                    name: "codTipoTratamiento2",
                                                    type: "select",
                                                    label: "Descripción tipo tratamiento",
                                                    placeholder:
                                                        "Ingrese la descripción del tipo de tratamiento",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                    options: tiposTratamiento,
                                                    associatedFormElement:
                                                        "tipoTratamiento2",
                                                },
                                                {
                                                    name: "porcentaje2",
                                                    type: "number",
                                                    label: "Porcentaje",
                                                    placeholder:
                                                        "Ingrese el porcentaje",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                },
                                                {
                                                    name: "observacionesGestionFinal",
                                                    type: "textarea",
                                                    label: "Observaciones gestión final",
                                                    placeholder:
                                                        "Ingrese las observaciones de la gestión final",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                },
                                                {
                                                    name: "ficheroGestorFinal",
                                                    type: "document",
                                                    label: "Documento gestor final",
                                                    placeholder:
                                                        "Seleccione el documento del gestor final",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                },
                                            ],
                                        },
                                        {
                                            title: "Cantidades generadas",
                                            titleVisible: true,
                                            elements: [
                                                {
                                                    name: "peso",
                                                    type: "number",
                                                    label: "Peso (KG)",
                                                    placeholder:
                                                        "Ingrese el peso",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                },
                                                {
                                                    name: "volumen",
                                                    type: "number",
                                                    label: "Volumen (m3)",
                                                    placeholder:
                                                        "Ingrese el volumen",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                },
                                            ],
                                        },
                                        {
                                            title: "Coste",
                                            titleVisible: true,
                                            elements: [
                                                {
                                                    name: "costeTransporte",
                                                    type: "number",
                                                    label: "Transporte",
                                                    placeholder:
                                                        "Ingrese el coste de transporte",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                },
                                                {
                                                    name: "costeGestion",
                                                    type: "number",
                                                    label: "Gestión",
                                                    placeholder:
                                                        "Ingrese el coste de gestión",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                },
                                                {
                                                    name: "costeColocacion",
                                                    type: "number",
                                                    label: "Colocación contenedor",
                                                    placeholder:
                                                        "Ingrese el coste de colocación de contenedor",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                },
                                                {
                                                    name: "costeAlquiler",
                                                    type: "number",
                                                    label: "Alquiler contenedor",
                                                    placeholder:
                                                        "Ingrese el coste de alquiler de contenedor",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                },
                                                {
                                                    name: "costeDocumento",
                                                    type: "number",
                                                    label: "Generación documento",
                                                    placeholder:
                                                        "Ingrese el coste de generación de documento",
                                                    required: false,
                                                    disabled: false,
                                                    labelVisible: true,
                                                    visible: true,
                                                },
                                            ],
                                        },
                                    ]}
                                    stateChangeOptions={[
                                        {
                                            value: "1",
                                            label: "Pendiente de validar",
                                        },
                                        {
                                            value: "2",
                                            label: "Validación con incidencias",
                                        },
                                        { value: "3", label: "Validada" },
                                    ]}
                                    stateChangeUrl="/api/Validaciones/SetValidacion"
                                    addApiUrl="/api/ResiduosObra/SetResiduoObra"
                                    editApiUrl="/api/ResiduosObra/UpdateResiduoObra"
                                    deleteApiUrl="/api/ResiduosObra/DeleteResiduoObra"
                                    searchTerms={[
                                        "residuo/nombre",
                                        "fechaRecogida",
                                        "peso",
                                        "costeFinal",
                                    ]}
                                    loading={loading}
                                    userCodAcceso={Number(user.codAcceso)}
                                    userCodPerfil={Number(user.role)}
                                    exportApiUrl="/api/ResiduosObra/obtener-informe1-mabe"
                                    extraPropExportKey="codObra"
                                    extraPropExportText="codObra"
                                />
                            </div>

                            <div
                                style={{
                                    display:
                                        activeTabResiduos === "tarifas"
                                            ? "block"
                                            : "none",
                                }}
                            >
                                <Table
                                    columns={[
                                        {
                                            key: "gestor",
                                            label: "Gestor",
                                            visible: true,
                                            sortable: true,
                                        },
                                        {
                                            key: "tarifa",
                                            label: "Tarifa",
                                            visible: true,
                                            sortable: false,
                                        },
                                    ]}
                                    keyProp="codTarifa"
                                    dataTable={tarifas}
                                    noResultsMessage="No hay tarifas disponibles"
                                    rowsPerPage={10}
                                    showCheckboxes={false}
                                    elementName="Tarifa"
                                    userCodAcceso={Number(user.codAcceso)}
                                    userCodPerfil={Number(user.role)}
                                    loading={loading}
                                />
                            </div>

                            {!isMabe && (
                                <div
                                    style={{
                                        display:
                                            activeTabResiduos === "neveras"
                                                ? "block"
                                                : "none",
                                    }}
                                >
                                    <Table
                                        columns={[
                                            {
                                                key: "nombreNevera",
                                                label: "Nevera",
                                                visible: true,
                                                sortable: false,
                                            },
                                            {
                                                key: "cantidadNeveras",
                                                label: "Cantidad neveras",
                                                visible: true,
                                                sortable: true,
                                            },
                                            {
                                                key: "residuosAprovechados",
                                                label: "Residuos aprovechados (kg)",
                                                visible: true,
                                                sortable: true,
                                            },
                                            {
                                                key: "residuosOrdinarios",
                                                label: "Residuos ordinarios (kg)",
                                                visible: true,
                                                sortable: true,
                                            },
                                            {
                                                key: "fechaSubida",
                                                label: "Fecha de subida",
                                                visible: true,
                                                sortable: true,
                                                type: "date",
                                            },
                                        ]}
                                        dataTable={neveras}
                                        formElements={[
                                            {
                                                elements: [
                                                    {
                                                        name: "nombreNevera",
                                                        type: "text",
                                                        label: "Nombre nevera",
                                                        placeholder:
                                                            "Ingrese nombre nevera",
                                                        required: false,
                                                        disabled: false,
                                                        labelVisible: true,
                                                        visible: true,
                                                    },
                                                    {
                                                        name: "cantidadNeveras",
                                                        type: "number",
                                                        label: "Cantidad neveras",
                                                        placeholder:
                                                            "Ingrese cantidad neveras",
                                                        required: false,
                                                        disabled: false,
                                                        labelVisible: true,
                                                        visible: true,
                                                    },
                                                    {
                                                        name: "residuosAprovechados",
                                                        type: "number",
                                                        label: "Residuos aprovechados",
                                                        placeholder:
                                                            "Ingrese residuos aprovechados",
                                                        required: false,
                                                        disabled: false,
                                                        labelVisible: true,
                                                        visible: true,
                                                    },
                                                    {
                                                        name: "residuosOrdinarios",
                                                        type: "number",
                                                        label: "Residuos ordinarios",
                                                        placeholder:
                                                            "Ingrese residuos ordinarios",
                                                        required: false,
                                                        disabled: false,
                                                        labelVisible: true,
                                                        visible: true,
                                                    },
                                                    {
                                                        name: "codObra",
                                                        type: "text",
                                                        label: "CodObra",
                                                        required: false,
                                                        disabled: false,
                                                        labelVisible: false,
                                                        visible: false,
                                                        defaultValue: id,
                                                    },
                                                ],
                                            },
                                        ]}
                                        noResultsMessage="No hay neveras disponibles"
                                        rowsPerPage={10}
                                        searchTerms={"nombreNevera"}
                                        showCheckboxes={false}
                                        elementName="Nevera"
                                        keyProp="codNevera"
                                        actions={["Editar", "Eliminar"]}
                                        addApiUrl="/api/Neveras/AddNevera"
                                        editApiUrl="/api/Neveras/UpdateNevera"
                                        deleteApiUrl="/api/Neveras/DeleteNevera"
                                        onDataUpdate={(newData) =>
                                            setNeveras(newData)
                                        }
                                        userCodAcceso={Number(user.codAcceso)}
                                        userCodPerfil={Number(user.role)}
                                        loading={loading}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="ficha-centro__section">
                        {renderRMEGraficoContent()}
                    </div>

                    <div className="ficha-centro__section">
                        <div className="ficha-centro__section-header">
                            <h2>Documentación</h2>
                        </div>
                        <TabsNavigation
                            tabs={tabsDocumentacion}
                            activeTab={activeTabDocumentacion}
                            onTabChange={setActiveTabDocumentacion}
                        />
                        <div className="ficha-centro__section-content">
                            {renderDocumentacionContent()}
                        </div>
                    </div>

                    {/* <div className="ficha-centro__section">
                        <div className="ficha-centro__section-header">
                            <h2>Consumo</h2>
                        </div>
                        <div className="ficha-centro__section-content">
                            {renderConsumo()}
                        </div>
                    </div> */}
                </div>
            )}
        </DetalleLayout>
    );
}
